import { AnalyticsPromotionImpressionObjectException } from '../errors/analyticsError';
import Logger from '../utils/analyticsLogger';
import DataObject from './DataObject';

export default class ArticleImpressionObject extends DataObject {
  constructor(data) {
    super('nievent', data);

    this.category = 'Ecommerce';
    /* istanbul ignore else */
    if (data.category) {
      Logger.warn(
        `[AnalyticsPromotionImpressionObjectException] Category always defaults to "Ecommerce" (L'Oréal guideline), currently [${data.category}] was provided`,
        data,
        false
      );
    }

    this.action = 'Promotion Impressions';
    /* istanbul ignore else */
    if (data.action) {
      Logger.warn(
        `[AnalyticsPromotionImpressionObjectException] Action always defaults to "Promotion Impressions" (L'Oréal guideline), currently [${data.action}] was provided`,
        data,
        false
      );
    }

    this.label = '__pageCategory__';
    /* istanbul ignore else */
    if (data.label) {
      this.label = data.label;
    }

    /* istanbul ignore next */
    if (!data.promotions || data.promotions.length === 0) {
      Logger.error(
        '[AnalyticsPromotionImpressionObjectException] Promotion(s) are required for a promotionImpression',
        data
      );
      throw new AnalyticsPromotionImpressionObjectException(
        'Promotion(s) are required for a promotionImpression'
      );
    }
  }

  initEcommerce() {
    this.result.ecommerce = this.result.ecommerce || {};
    this.result.ecommerce.promoView = this.result.ecommerce.promoView || {};
  }

  set event_name(event_name) {
    this.result.event_name = this.setProperty(event_name);
  }

  set category(category) {
    this.result.eventCategory = this.setProperty(category, false);
  }

  set action(action) {
    this.result.eventAction = this.setProperty(action, false);
  }

  set label(label) {
    this.result.eventLabel = this.setProperty(label, false);
  }

  set promotions(promotions) {
    this.initEcommerce();
    this.result.ecommerce.promoView.promotions = promotions;
  }
}
